var exports = {
  "L": "navigationCursor__qGrcex",
  "o": "codeNavigationCursor__wHv11f",
};

module.exports = exports;
